import { Typewriter } from "@/components/landing/Typewriter";

export const MODULES = [["F1", "Setups"], ["F2", "Order Flow"], ["F3", "Pulse"], ["F4", "Research"], ["F5", "News"]];
export const CMDS = ["tq.scan --markets 176 --strategies 10+ --grade A", "tq.pulse --breakout-watch --vol >3x", "tq.flow BTC --footprint --5m", "tq.research ETH --worth-it", "tq.news --impact high --live"];

export const Heading = () => (
  <h1 data-testid="hero-heading" className="max-w-4xl font-display text-[2.25rem] font-semibold leading-[1.02] tracking-[-0.035em] text-[#ECEBE4] sm:text-5xl lg:text-[4rem]">
    The institutional terminal. <span className="whitespace-nowrap text-[#7D8390] sm:block">Built for retail.</span>
  </h1>
);

export const Lead = ({ className = "" }) => (
  <h2 data-testid="hero-seo-subline" className={`max-w-[640px] text-[15px] leading-relaxed text-[#9DA3AE] md:text-base ${className}`}>
    Real-time order flow, liquidations and whale data from Hyperliquid, Binance, OKX, Bybit and Coinbase, streamed with low latency into one crypto trading terminal.
  </h2>
);

const SHORT = { "Order Flow": "Flow" };

export const Chips = ({ active, onPick }) => (
  <ul data-testid="hero-module-chips" className="grid w-full grid-cols-5 gap-1.5 font-mono text-[10px] uppercase tracking-[0.08em] sm:flex sm:w-auto sm:flex-wrap sm:items-center sm:gap-x-4 sm:gap-y-2 sm:text-[11px] sm:tracking-[0.16em]">
    {MODULES.map(([k, l], n) => (
      <li key={k}>
        <button type="button" onClick={() => onPick?.(n)} data-testid={`hero-chip-${k.toLowerCase()}`} aria-keyshortcuts={k} aria-pressed={active === n}
          className={`flex w-full flex-col items-center gap-1 border px-1 py-2 transition-colors duration-300 hover:text-[#ECEBE4] sm:w-auto sm:flex-row sm:gap-1.5 sm:border-0 sm:p-0 ${active === n ? "border-[#FFB224]/40 bg-[#FFB224]/[0.06] text-[#ECEBE4]" : "border-white/[0.08] text-[#9DA3AE]"}`}>
          <span className="text-[#FFB224]">{k}</span>
          <span className="sm:hidden">{SHORT[l] || l}</span><span className="hidden sm:inline">{l}</span>
        </button>
      </li>
    ))}
    <li className="hidden font-mono text-[10px] normal-case tracking-normal text-[#5A6170] lg:block">press F1–F5</li>
  </ul>
);

export const Cmd = ({ className = "" }) => (
  <div data-testid="hero-command" className={`flex h-[1.6em] items-center gap-2 overflow-hidden whitespace-nowrap font-mono text-[12px] text-[#C9CCD1] ${className}`}>
    <span className="text-[#BACD1C]">❯</span>
    <Typewriter words={CMDS} typingSpeed={45} deleteSpeed={18} pause={1800} cursorClassName="text-[#BACD1C]" />
  </div>
);

const Eyebrow = () => <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#7D8390]">TradrQuant · institutional market intelligence</p>;

export const VARIANTS = {
  A: () => (
    <>
      <Eyebrow />
      <div className="mt-6"><Heading /></div>
      <Lead className="mt-5" />
      <div className="mt-7 flex max-w-4xl flex-col gap-3 border-t border-white/[0.07] pt-4 md:flex-row md:items-center md:justify-between">
        <Chips />
        <Cmd className="text-[11px] text-[#7D8390]" />
      </div>
    </>
  ),
  B: () => (
    <>
      <Eyebrow />
      <div className="mt-6"><Heading /></div>
      <Lead className="mt-5" />
      <p className="mt-3 max-w-[640px] text-[13px] text-[#5A6170]">Setups, order flow, pulse screener, research and news in one terminal.</p>
      <Cmd className="mt-5 text-[11px]" />
    </>
  ),
  C: () => (
    <>
      <Cmd className="text-[11px] text-[#7D8390]" />
      <div className="mt-5"><Heading /></div>
      <Lead className="mt-5" />
      <div className="mt-6"><Chips /></div>
    </>
  ),
};
